import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/Shop.css';
import ls from 'local-storage'
import axios from 'axios';
import Loading from "./Loading";
import Retry from "./Retry";
import TopNav from "./TopNav";
import Products from "./Products";
import Product from "../Modules/Product";
import AppBody from "./AppBody";
import Comment from "../Modules/Comment";
import Comments from "./Comments";

class Shops extends React.Component{
    list =[];
    hasMoreProductToLoad = true;
    content = document.getElementsByClassName("content")[0];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            activeMenu: 0,
            cat_id: "",
            sub_cat_id: "",
            comments_page: 1,
            products_page: 1,
            retry: false,
            error: false,
            error_text: "",
            url:"",
            shopId:null,
            loading: true,
            shopTime: {StartHour:"00:00",EndHour:"00:00"},
            shopImage:"" ,
            shopName:"" ,
            shopNumber:"" ,
            shopDescription:"" ,
            shopAddress:"" ,
            ready_time:"" ,
            shopRate:"" ,
            products: [],
            Category: [{id:"",cat_name:"همه"}],
            SubChildCategory: [],
            buy_list: [],
            comments:[],
            CommentStatus:[],
            prevY: 0
        };
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleCategoryClick = this.handleCategoryClick.bind(this);
        this.handleSubCategoryClick = this.handleSubCategoryClick.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.tabRender = this.tabRender.bind(this);
    }
    componentWillMount() {
        if(ls.get("store_id") == null)
            this.props.history.push("/");
        else
            this.setState({shopId:ls.get("store_id")});
    }
    componentDidMount = () => {
        let target = document.getElementById("topCategories");
        if(target)
        target.addEventListener('wheel', event => {
            let toLeft  = event.deltaY > 0 && target.scrollLeft > 0;
            let toRight = event.deltaY < 0 && target.scrollLeft < target.scrollWidth - target.clientWidth ;

            if (toLeft || toRight) {
                event.preventDefault();
                target.scrollLeft -= event.deltaY;
            }
        });
        if(!!ls.get("list"))
            this.list = ls.get("list");
        if(this.list  != null && this.list.length > 0)
            this.setState({buy_list:this.list});

        this.content = document.getElementsByClassName("content")[0];
        this.getShopData();
        this.content.addEventListener("scroll",this.handleScroll,false);
    };

    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );

        return (
            <AppBody loading={this.state.loading} showBotNav={true} name={"فروشگاه "+this.state.shopName} type={" bg-white"}>

                <div id={"shopImgElm"}>
                    <img id={"shopImg"} src={urls.SiteUrl+this.state.shopImage}/>
                </div>
                <div id={"shopNavRow"}>
                    <button className={"shopNavButton"+((this.state.activeMenu === 0)?" active":"")} onClick={(e)=>this.switchTabs(e,this,0)}>منو</button>
                    <button className={"shopNavButton"+((this.state.activeMenu === 1)?" active":"")} onClick={(e)=>this.switchTabs(e,this,1)}>نظرات</button>
                    <button className={"shopNavButton"+((this.state.activeMenu === 2)?" active":"")} onClick={(e)=>this.switchTabs(e,this,2)}>توضیحات</button>
                </div>
                {this.tabRender()}
            </AppBody>
        );
    }

    tabRender(){

        if(this.state.activeMenu == 0)
            return (
                <div>
                    {this.renderCategories()}
                    {this.renderSubCategories()}
                    <Products products={this.state.products} showStoreName={false}/>
                </div>);
        else if(this.state.activeMenu == 1)
            return (
                <Comments comments={this.state.comments}/>
            );

        else if(this.state.activeMenu == 2)
            return (
                <div id={"store_details"}>
                    <div className={"store_details_50"}><div className={"details_tag"}>نام فروشگاه</div><div className={"details_value"}>{this.state.shopName}</div></div>
                    <div className={"store_details_50"}><div className={"details_tag"}>میانگین زمان آماده سازی</div><div className={"details_value"}>{this.state.ready_time}</div></div>
                    <div className={"store_details_50"}><div className={"details_tag"}>ساعت کاری</div><div className={"details_value"}>{this.state.shopTime.StartHour} تا {this.state.shopTime.EndHour}</div></div>
                    <div className={"store_details_50"}><div className={"details_tag"}>تلفن فروشگاه</div><div className={"details_value"}>{this.state.shopNumber}</div></div>
                    <div className={"store_details_100"}><div className={"details_tag"}>آدرس</div><div className={"details_value"}>{this.state.shopAddress}</div></div>
                    <div className={"store_details_100"}><div className={"details_tag"}>توضیحات</div><div className={"details_value"}>{this.state.shopDescription}</div></div>
                </div>
            );

        return (
            <div>
                {this.renderCategories()}
                {this.renderSubCategories()}
                <Products products={this.state.products} showStoreName={false}/>
            </div>);
    };

    switchTabs(event,elm,type){
        switch (type) {
            case 0:this.getProducts();break;
            case 1:this.getStoreComments();this.hasMoreProductToLoad = false;break;
            case 2:this.getStoreComments();this.hasMoreProductToLoad = false;break;

        }
        let navs = document.getElementsByClassName("shopNavButton");
        for (let i = 0; i < navs.length; i++)
            navs[i].className = "shopNavButton";
        event.target.className += " active";
        this.setState({activeMenu:type});
    }

    getShopData(){
        this.setState({loading:true});
        axios.get(urls.baseUrl+urls.getShop+"?shop_id="+this.state.shopId+"&token="+ls.get("token"))
            .then(res => {
                console.log("Shop Data",res.data);
                if(res.data.code == 200){
                    this.setState({
                        shopDescription:res.data.shopinfo.shop_desc,
                        shopAddress:res.data.shopinfo.address,
                        ready_time:res.data.shopinfo.shop_average_amadesazi,
                        shopNumber:res.data.shopinfo.shop_number,
                        shopRate:res.data.shopinfo.shop_rate,
                        shopImage:res.data.shopinfo.shop_img,
                        shopName:res.data.shopinfo.shopname,
                        shopTime:{StartHour:res.data.ShopTime.StartHour,EndHour:res.data.ShopTime.EndHour},
                        loading:false}, ()=>{this.getProducts()});

                    if(!res.data.time_status)
                        alert(res.data.message);
                }
                else{
                    this.setState({loading:false});
                    alert(res.data.message)
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({retry:true,loading:false});
            });
    }
    getStoreComments(){
        this.setState({loading:true});

        let data = {
            token:ls.get("token"),
            id:this.state.shopId,
            comments_of:0,
        };
        axios.post(urls.baseUrl+urls.getComments,data)
            .then(res => {
                if(res.data.code == 200){
                    let comments = [];
                    res.data.comments.forEach((item)=>{
                        comments.push(new Comment(item));
                    });
                    this.setState({
                        comments:comments,
                        CommentStatus:res.data.CommentStatus,
                        loading:false});
                }
                else{
                    alert(res.data.message)
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({retry:true,loading:false});
            });
    }
    addProductToList(id){
        if(this.list  == null)
            this.list  = [];
        let found = this.list.some(el=>el.product_id === id);
        let productIndex = this.state.products.findIndex(product=>product.product_id === id);
        let product_number = this.state.products[productIndex].product_number;
        if(!found){
            let clone = Object.assign({},this.state.products[productIndex]);
            this.list.push(clone);
            this.list[this.list.length-1].product_number = 1;
            this.list[this.list.length-1].product_max_number = product_number;
        }

        else{
            let index = this.list.findIndex((cart=>cart.product_id === id));
            if(product_number == null || product_number > this.list[index].product_number)
                this.list[index].product_number +=1;
        }

        ls.set("list",this.list);
        this.setState({buy_list:this.list});
    }
    subProductToList(id){
        let found = this.list.some(el=>el.product_id === id);
        if(found){
            let index = this.list.findIndex((cart=>cart.product_id === id));
            this.list[index].product_number -=1;
            if(this.list[index].product_number <= 0)
                this.list.splice(index,1);
        }
        console.log("list : ",this.list);

        ls.set("list",this.list);
        this.setState({buy_list:this.list});
    }
    renderCategories(){
        return (
            <div id={"topCategories"} >
                {this.state.Category.map((cat)=>{
                   return (
                       <div className={"topCatItem"+((this.state.cat_id == cat.id)?" active":"")} onClick={(this.state.cat_id != cat.id)?()=>this.handleCategoryClick(cat.id):()=>this.handleCategoryClick()}>
                           {cat.cat_name}
                       </div>
                   )
                })}
            </div>
        )
    }
    renderSubCategories(){
        return (
            <div id={"topSubCategories"} >
                {this.state.SubChildCategory.map((cat)=>{
                   return (
                       <div className={"topSubCatItem"+((this.state.sub_cat_id == cat.id || this.state.sub_cat_id == null)?" active":"")} onClick={(this.state.sub_cat_id != cat.id)?()=>this.handleSubCategoryClick(cat.id):()=>this.handleSubCategoryClick()}>
                           {cat.cat_name}
                       </div>
                   )
                })}
            </div>
        )
    }
    handleCategoryClick(id){
        if(id != null)
            this.setState({cat_id:id,products_page:1,sub_cat_id:null},() => {
                this.getProducts();
            });
    }
    handleSubCategoryClick(id){
        if(id != null)
            this.setState({sub_cat_id:id,products_page:1},() => {
                this.getProducts(false);
            });
    }
    handleProductClick(id){

    }
    handleRedirect(menu){
        switch (menu.menuen) {
            case "store":
                this.setState({redirect:true,url:"/categories"});
                break;
            case "new_products":
                this.setState({redirect:true,url:"/new_products"});
                break;
            default :
                break;
        }

    }
    getProducts(clearSubChild = true){
        this.setState({loading:true});
        let subCats = this.state.SubChildCategory;
        if(clearSubChild)
            subCats = [];
        if(this.state.products_page === 1)
            this.setState({ products: [],SubChildCategory: subCats});
        axios.get(urls.baseUrl+urls.getProductsOfStore+"?shop_id="+this.state.shopId
            +"&cat_id="+((this.state.sub_cat_id == null)?this.state.cat_id:this.state.sub_cat_id)
            +"&page="+this.state.products_page
            +"&city_id="+ls.get("city_id"))
            .then(res => {
                console.log("products : ",res.data);
                if(res.data.code == 200){
                    if(res.data.Products.length === 0)
                        this.hasMoreProductToLoad = false;
                    else
                        this.hasMoreProductToLoad = true;

                    let cats = [];
                    cats.push({id:"",cat_name:"همه"});
                    cats = [...cats,...res.data.ChildCategory];
                    let products = [];
                    res.data.Products.forEach((product)=>{
                        products.push(new Product(product));
                    });

                    this.setState({
                        products:[...this.state.products, ...products],
                        Category:cats,
                        SubChildCategory:(this.state.sub_cat_id == null)?res.data.SubChildCategory:this.state.SubChildCategory,
                        loading:false},()=>{
                        this.content.addEventListener("scroll",this.handleScroll,false);
                    });

                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,loading:false},()=>{
                    this.content.addEventListener("scroll",this.handleScroll,false);
                });
            });


    }
    handleScroll = (event) => {
        if(!this.hasMoreProductToLoad){
            event.target.removeEventListener("scroll", this.handleScroll);
            return;
        }

        if(event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight < 2 && !this.isLoadingMore){
            event.target.removeEventListener("scroll", this.handleScroll);

            this.setState({products_page:this.state.products_page+1},() => {
                this.getProducts();
            })
        }
    };
}



export default Shops;
